var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/pullable.tsx";
import React from 'react';
import PullToRefresh from './pull-to-refresh';

/**
 * Pullable:
 * Basic "pull to refresh" without the refresh.
 * Just visual feedback.
 */
const Pullable = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(PullToRefresh // @ts-ignore
  , {
    refreshingContent: null,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 3
    }
  }, children);
};

export default Pullable;